import QuickJobsApi, { IPaginationParams } from ".";

class Applications {
  protected client: QuickJobsApi;

  constructor(client: QuickJobsApi) {
    this.client = client;
  }

  public getAll(jobId: number, params?: IPaginationParams) {
    return this.client.httpClient.get(`/jobs/${jobId}/applications`, {
      params: params
    });
  }
}

export default Applications;



// WEBPACK FOOTER //
// ./src/libs/quickjobs-api/applications.ts